var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExxonmobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0391 11.8927V4.59444L11.3623 0.945312L7.68557 4.59444V7.02718H0.332031V24.0564H22.3926V11.8927H15.0391ZM5.23439 21.6237H2.78321V19.1909H5.23439V21.6237ZM5.23439 16.7582H2.78321V14.3254H5.23439V16.7582ZM5.23439 11.8927H2.78321V9.45993H5.23439V11.8927ZM12.5879 21.6237H10.1367V19.1909H12.5879V21.6237ZM12.5879 16.7582H10.1367V14.3254H12.5879V16.7582ZM12.5879 11.8927H10.1367V9.45993H12.5879V11.8927ZM12.5879 7.02718H10.1367V4.59444H12.5879V7.02718ZM19.9415 21.6237H17.4903V19.1909H19.9415V21.6237ZM19.9415 16.7582H17.4903V14.3254H19.9415V16.7582Z",
    fill: "#C3CBD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExxonmobil);
export default __webpack_public_path__ + "static/media/exxonmobil.29e0637015396b0f99a3537b80f2d4a5.svg";
export { ForwardRef as ReactComponent };